import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=66460bba&scoped=true"
import script from "./PageSettings.vue?vue&type=script&lang=ts"
export * from "./PageSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66460bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66460bba')) {
      api.createRecord('66460bba', component.options)
    } else {
      api.reload('66460bba', component.options)
    }
    module.hot.accept("./PageSettings.vue?vue&type=template&id=66460bba&scoped=true", function () {
      api.rerender('66460bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/PageSettings.vue"
export default component.exports